module.exports = __webpack_public_path__ + "img/HeBo Trailers-45.9ae4c9c2.jpg";